// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"b8ef9e52","608":"75832223","787":"bfaad7ea"}[chunkId] + ".chunk.js";
};